// Change this value when the deployed API domain changes.
// Local development API: http://localhost:5000
const API_BASE_URL = process.env.REACT_APP_API_URL || "https://olive-ibis-563001.hostingersite.com";

export const API_URL = API_BASE_URL.replace(/\/$/, "");
export const apiUrl = (path) => `${API_URL}/${String(path).replace(/^\//, "")}`;
